export default function Bridge() {
  return (
    <section className="bridge">
      <div className="container">
        <h2>Co kdyby se všechna ta data přenesla<br />do Money S3 <span className="accent">sama</span>?</h2>
        <p>Bez přepisování. Bez chyb. Bez stresu.<br /><strong>Přesně k tomu jsme postavili SyncroX.</strong></p>
      </div>
    </section>
  );
}
